// angular
// 	.module("HeroPRO")
// 	.directive('hpTrainingBtn', trainingDirective);

export default function trainingDirective() {
    return {
        restrict: 'E',
        controller: 'TrainingBtnController',
        controllerAs: 'topic',
        // bindToController: true,
        scope: {
            advance: '&',
            retreat: '&',
            validate: '=',
            current: '=',
            parentClass: '@',
        },
        templateUrl: 'app/notificationCenter/modal/training/directives/trainingBtn/trainingBtn.html',
        link,
    };

    function link(scope, element) {
        element.on('click', (e) => {
            const target = e.target;
            target.blur();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/training/directives/trainingBtn/trainingBtnDirective.js